import { CROPPER_INVALID_SIZE } from './cropperTypes';
import { generateFormData } from '../fileUpload/fileUploadUtils';
export const getCroppedThumbnailFile = ({
  cropper,
  fileName,
  minHeight,
  minWidth
}) => {
  return new Promise((resolve, reject) => {
    cropper.current.getCroppedImage().then(blob => {
      const image = new Image();
      image.onload = () => {
        const {
          height: imageHeight,
          width: imageWidth
        } = image;
        if (minHeight && minWidth) {
          // Condition offset due to edge case with 1280x720 image uploads
          // This accounts for croppie returning a 1280x716 image in this edge case
          if (imageHeight < minHeight - 4 || imageWidth < minWidth) {
            reject(new Error(CROPPER_INVALID_SIZE, {
              cause: {
                minHeight,
                minWidth,
                imageHeight,
                imageWidth
              }
            }));
          }
        }
        const formData = generateFormData({
          file: blob,
          fileName
        });
        resolve(formData);
      };
      image.src = URL.createObjectURL(blob);
    }).catch(reject);
  });
};